import { render, staticRenderFns } from "./CreateCollector.vue?vue&type=template&id=60441113&"
import script from "./CreateCollector.vue?vue&type=script&lang=js&"
export * from "./CreateCollector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports